import * as API from "@/services/API";

export default {
  getPrivacyPolicyField() {
    return new Promise((resolve, reject) => {
      API.apiClient
        .get(`/privacy-policy-get-fields`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
